export default "__VITE_ASSET__CGeZCx31__"